import styles from './LandingPageRecipes.module.scss';
import RedirectImage from './RedirectImage/RedirectImage';

export default function LandingPageRecipes({ cmsData = {}, redirections = {} }) {
  const section = cmsData?.fields?.sections?.[0];
  const recipesHeader = section?.recipes_header || '';
  const redirectionsIds = section?.redirectionLink || [];
  const redirectionsRecipes = redirections.filter(redirection => redirectionsIds.includes(redirection.uuid));
  return (
    <section className={styles.container}>
      {recipesHeader && (
        <div className={styles.listHeader}>
          <h2 className={styles.listTitle}>{recipesHeader}</h2>
        </div>
      )}
      <div className={styles.listContainer}>
        {redirectionsRecipes?.map(tile => (
          <RedirectImage key={tile?.uuid} tile={tile} altText="συνταγή" />
        ))}
      </div>
    </section>
  );
}
